module.exports = __webpack_public_path__ + "img/4.a74ea126.jpg";